import React, { useState, useEffect } from 'react';
import './Hero.css';
import { Link } from 'react-router-dom';

import SocialIcon from './SocialIcon';

const Nav = ({logo,logoSize,hamburgerColor = "white" ,plusColor = "white"}) => {

  const [menuOpen, setMenuOpen] = useState(false);
  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    // Handle scrolling to toggle the fixed navbar
    const handleScroll = () => {
      if (window.scrollY > 100) { // Adjust scroll threshold here
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };
    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);



  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <div className="nav-container">
      {/* Logo and Hamburger Menu */}
      <nav className={`navbar ${isFixed ? 'fixed' : ''}`}>
        <div className="logo-container">
          <img src={logo} alt="Logo" className="logo" style={{ width: logoSize || "150px" }}  />
        </div>
      </nav>

      <div className={`hamburger ${menuOpen ? 'menu-open' : ''}`} onClick={toggleMenu} >
        <input
            type="checkbox"
            id="menuCheckbox"
            checked={menuOpen}
            onChange={toggleMenu}
          />
        <span style={{ backgroundColor: menuOpen ? plusColor : hamburgerColor }}></span>
        <span style={{ backgroundColor: menuOpen ? plusColor : hamburgerColor }}></span>
      </div>


      {/* Vertical Menu */}
      {menuOpen && (
        <div className={`vertical-menu ${menuOpen ? 'open' : ''}`}>
          <ul>
            <li>
              <Link to="/about" onClick={toggleMenu}>
                About Us
              </Link>
            </li>
            <li>
              <Link to="/project" onClick={toggleMenu}>
                Projects
             </Link>
            </li>
            <li>
            <Link to="/media" onClick={toggleMenu}>
               Media
            </Link>
            </li>
            <li>
            <Link to="/blog" onClick={toggleMenu}>
              Blogs
            </Link>
            </li>
            <li>
              <Link to="/contact" onClick={toggleMenu}>
              Contact
            </Link></li>
          </ul>

          {/* Social Media Icons */}
          <SocialIcon />
        </div>
      )}
    </div>
  );
};

export default Nav;
